<template>
  <footer class="site-footer">
    <p class="site-footer__cite">
      <cite>Formula 1 Statistics</cite> by
      <a href="mailto:email@email.email">Luke Fryer</a>
    </p>
    <!-- <p class="site-footer__info">
      Powered by
      <a href="https://ergast.com/" target="ergast"
      rel="noopener noreferrer">ergast.com</a>
    </p> -->
  </footer>
</template>
<script>

export default {
  name: 'site-footer'
}
</script>
